import React from "react";
import ResponsivePhotoWithText from "../ui/element/ResponsivePhotoWithText";
import ResponsiveElement from "../ui/element/ResponsiveElement";
import DependentOnScreenSizeElement from "../ui/element/DependentOnScreenSizeElement";
import SimpleTestimonial from "../funnel/after-optin/webinar/sales-page/SimpleTestimonial";
import {Link} from "react-router-dom";
import FaqList from "../ui/faq/FaqList";
import AnimatedLink from "../ui/motion/AnimatedLink";
import AnimatedButton from "../ui/motion/AnimatedButton";
import VideoWithPlayButton from "../ui/video/VideoWithPlayButton";
import {kedV2CourseStructure} from "../../model/user/learning-course/LearningCourse";
import Heading from "../common/header/Heading";
import {motion} from "framer-motion";
import SocialProofBar from '../funnel/after-optin/webinar/sales-page/sections/SocialProofBar';
import {reviews} from '../../model/common/Review';
import TutoringComparisonSection from '../funnel/after-optin/webinar/sales-page/sections/TutoringComparisonSection';

interface ReferralKedSalesPageProps {
    referralCode: string;
    referrerName?: string;
    onInitPurchase: () => Promise<void>;
    isSubmitting: boolean;
    transactionUrl: string | null;
}

const glassCard = {
    background: 'linear-gradient(145deg, rgba(42, 51, 66, 0.35) 0%, rgba(26, 26, 46, 0.55) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.06)',
};

function stripHtml(html: string): string {
    return html.replace(/<[^>]*>/g, '').trim();
}

const reviewCount = reviews.length;
const averageRating = reviews.reduce((sum, r) => sum + r.rating, 0) / reviewCount;
const displayAverage = averageRating.toFixed(2).replace('.', ',');

const curatedSalesReviews = reviews.filter(r =>
    (r.name === 'Krzysztof' && r.addedAt === '2026-02-23') ||
    (r.name === 'Lidia' && r.addedAt === '2026-01-13') ||
    (r.name === 'Julia' && r.addedAt === '2025-10-12') ||
    (r.name === 'Anastazja' && r.addedAt === '2025-09-26') ||
    (r.name === 'Emilia' && r.addedAt === '2026-01-20') ||
    (r.name === 'Weronika' && r.addedAt === '2025-08-31') ||
    (r.name === 'Alicja' && r.addedAt === '2026-02-01') ||
    (r.name === 'Maria' && r.addedAt === '2025-08-24') ||
    (r.name === 'Szymon' && r.addedAt === '2026-02-12')
);

export default function ReferralKedSalesPage({
                                                 referralCode,
                                                 referrerName,
                                                 onInitPurchase,
                                                 isSubmitting,
                                                 transactionUrl
                                             }: ReferralKedSalesPageProps) {
    const referralPrice = 3000;

    function renderPricingSection() {
        return (
            <div className="mw-md-5xl mx-auto">
                <div>
                    <p className="text-warning fw-medium mb-4 fs-10">
                        <i className="bi bi-gift me-2"></i>
                        Oferta z polecenia{referrerName && <> od <span className="fw-bold">{referrerName}</span></>} —
                        dostępna tylko przez link polecający!
                    </p>

                    <h2 className="mb-5 text-success">
                        🔥 Zyskaj <span className="fw-bold"><u>3000 PLN</u> rabatu</span> na Kurs KED 2.0! 🔥
                    </h2>

                    <p className="text-white fw-medium fs-5">
                        <span className="text-decoration-line-through text-danger fw-bold me-2">6000 zł</span>
                        <span className="text-success fw-bold">{referralPrice} zł</span>
                    </p>
                    <p className="text-white fw-medium">
                        Jednorazowa płatność <span className="fw-bold text-success">{referralPrice} zł</span> lub{" "}
                        <span className="fw-bold text-success">3 raty 0% (1000 zł/mc)</span>{" "}
                        bez żadnych dodatkowych kosztów (0% prowizji)!
                    </p>

                    <div className='rounded-3 p-3 mt-4 mw-md-xl mx-auto'
                         style={{...glassCard, border: '1px solid rgba(42, 209, 103, 0.15)'}}>
                        <p className='fs-10 mb-2 text-white fw-semibold'>W pakiecie otrzymujesz:</p>
                        <div className='d-flex flex-column gap-1 fs-11'>
                            <span><i className='bi bi-check-circle-fill text-success me-2'></i><b>Kurs Efektywnego Działania 2.0</b> dla Twojego dziecka</span>
                            <span><i
                                className='bi bi-check-circle-fill text-success me-2'></i>Dostęp do <b>społeczności</b> i cotygodniowych <b>spotkań online</b></span>
                            <span><i className='bi bi-check-circle-fill text-success me-2'></i><b>Dożywotni dostęp</b> do wszystkich materiałów</span>
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-column align-items-center justify-content-center mt-4">
                    <AnimatedButton
                        className="btn btn-success btn-lg fw-bold purchase-button"
                        disabled={isSubmitting}
                        onClick={() => onInitPurchase()}
                        type="button"
                    >
                        Kupuję już teraz
                    </AnimatedButton>
                    {transactionUrl && (
                        <div className="text-center mt-2 mb-2">
                            <p className='fs-10 text-warning mb-1'>
                                Jeżeli okno płatności nie otworzyło się automatycznie, <a href={transactionUrl}
                                                                                          className='text-success text-decoration-underline'>kliknij
                                tutaj aby dokonać płatność</a>.
                            </p>
                            <p className='fs-10 text-warning mb-0'>
                                Jeżeli powyższy link nie działa, <span
                                className='text-info text-decoration-underline'
                                style={{cursor: 'pointer'}}
                                onClick={() => {
                                    navigator.clipboard.writeText(transactionUrl);
                                }}
                            >kliknij tutaj, aby skopiować link do płatności</span> i wklej go w nowej karcie.
                            </p>
                        </div>
                    )}
                </div>
                <p className={`mb-1 fs-13 fw-medium text-white text-center mw-md-xl mx-auto mt-2`}>
                    <span>Dokonując płatności akceptujesz </span>
                    <Link target="_blank" className="text-success link-success" to="/polityka-prywatnosci">
                        politykę prywatności
                    </Link>
                    <span> oraz </span>
                    <Link target="_blank" className="text-success link-success" to="/regulamin">
                        regulamin
                    </Link>
                    <span>. Wszystkie instrukcje dotyczące dostępu do kursu zostaną wysłane na adres email podany przy płatności.</span>
                </p>
            </div>
        );
    }

    return (
        <>
            <div className="mw-md-6xl mx-auto text-center text-white">
                {referrerName && (
                    <motion.div
                        className="badge bg-success bg-opacity-25 text-success px-3 py-2 rounded-pill mb-4"
                        animate={{scale: [1, 1.06, 1]}}
                        transition={{duration: 3.5, repeat: Infinity}}
                        style={{fontSize: '0.85rem', border: '1px solid rgba(42, 209, 103, 0.3)'}}
                    >
                        🎁 {referrerName} poleca Ci ten Kurs
                    </motion.div>
                )}

                <DependentOnScreenSizeElement mobileElement={<>
                    <h2 className='mb-0 text-center mw-md-5xl mx-auto font-heading mb-1 fs-4 text-white'>Twoje dziecko
                        samo <span className='text-success'>ogarnia</span> naukę.</h2>
                    <p className='text-white fw-medium mw-md-3xl mx-auto fs-9 mt-3'>Ty wreszcie możesz <span
                        className='text-warning fw-bold'>odetchnąć.</span></p>
                    <p className='text-secondary-light mw-md-3xl mx-auto fs-11 mt-3'>Bez ciągłego pilnowania,
                        przypominania czy nadzorowania z Twojej strony.</p>
                    <p className='text-warning fw-medium mw-md-3xl mx-auto fs-11 mt-3'>Dzięki sprawdzonemu przez 950+
                        nastolatków Kursowi Efektywnego Działania 2.0.</p>
                </>} desktopElement={<>
                    <h2 className='mb-0 text-center mw-md-5xl mx-auto font-heading mb-1 fs-3 text-white'>Twoje dziecko
                        samo <span className='text-success'>ogarnia</span> naukę.</h2>
                    <p className='text-white fw-medium mw-md-4xl mx-auto fs-7 mt-4'>Ty wreszcie możesz <span
                        className='text-warning fw-bold'>odetchnąć.</span></p>
                    <p className='text-secondary-light mw-md-4xl mx-auto fs-10 mt-3'>Bez ciągłego pilnowania,
                        przypominania czy nadzorowania z Twojej strony.</p>
                    <p className='text-warning fw-medium mw-md-4xl mx-auto fs-10 mt-3'>Dzięki sprawdzonemu przez 950+
                        nastolatków Kursowi Efektywnego Działania 2.0.</p>
                </>}/>

                <div className="mt-6">
                    <VideoWithPlayButton
                        vimeoVideoId='1168073752'
                        id='intro-video'
                        customDivWrapperClasses='mw-md-3xl mx-auto mb-0 position-relative'
                        rounded={true}
                        doNotAutoplay={true}
                    />
                </div>

                {/* Social Proof Bar */}
                <SocialProofBar/>

                <motion.div
                    animate={{y: [0, 8, 0]}}
                    transition={{duration: 2, repeat: Infinity, ease: 'easeInOut'}}
                    className="text-center mt-6 mb-4"
                >
                    <i className="bi bi-chevron-down text-white-50 fs-5"></i>
                </motion.div>

                {/* PROBLEM SECTION — "Czy to brzmi znajomo?" */}
                <motion.div
                    id="czy-to-brzmi-znajomo"
                    initial={{opacity: 0, y: 20}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.6}}
                    className="text-center mt-16 mb-10"
                >
                    <h2 className="fs-3 fw-bold text-white mb-4">Czy to brzmi znajomo?</h2>
                    <p className="fs-9 text-secondary-light">Jeśli chociaż jedno z tych zdań dotyczy Ciebie —
                        jesteś we właściwym miejscu.</p>
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true}}
                    variants={{
                        hidden: {opacity: 0},
                        visible: {opacity: 1, transition: {staggerChildren: 0.12}}
                    }}
                    className="mw-md-4xl mx-auto"
                >
                    {[
                        'Regularnie musisz przypominać o lekcjach i nauce',
                        'Czujesz, że jeśli odpuścisz kontrolę — wszystko się posypie',
                        'Edukacja stała się polem bitwy w Waszym domu',
                        'Widzisz potencjał dziecka, ale nie wiesz, jak go odblokować',
                        'Masz dość bycia jedyną osobą, której zależy na nauce',
                        'Martwisz się o przyszłość, ale jednocześnie nie masz już siły'
                    ].map((point, index) => (
                        <motion.div
                            key={index}
                            variants={{
                                hidden: {opacity: 0, x: -20},
                                visible: {opacity: 1, x: 0, transition: {duration: 0.5}}
                            }}
                            className="d-flex align-items-center gap-4 p-4 rounded-3 mb-3"
                            style={{
                                background: 'linear-gradient(145deg, rgba(42, 51, 66, 0.35) 0%, rgba(26, 26, 46, 0.55) 100%)',
                                border: '1px solid rgba(255, 255, 255, 0.06)'
                            }}
                        >
                            <div
                                className="d-flex align-items-center justify-content-center flex-shrink-0"
                                style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '50%',
                                    background: 'rgba(239, 68, 68, 0.15)'
                                }}
                            >
                                <i className="bi bi-x-lg text-danger fs-9"></i>
                            </div>
                            <span className="text-white fw-medium fs-10">{point}</span>
                        </motion.div>
                    ))}
                </motion.div>

                <motion.div
                    initial={{opacity: 0, y: 20}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.6, delay: 0.3}}
                    className="text-center mt-10"
                >
                    <p className="fs-9 text-secondary-light mw-md-3xl mx-auto">
                        To nie Twoja wina. I nie wina Twojego dziecka.
                    </p>
                    <p className="fs-9 text-secondary-light mw-md-3xl mx-auto mt-2">
                        Tylko nikt Wam nie pokazał innej drogi.
                    </p>
                    <p className="fs-7 text-warning fw-semibold mt-3">
                        Szkoła uczy <strong className="text-white">CZEGO</strong> się uczyć, ale nigdy nie
                        pokazała <strong className="text-white">JAK.</strong>
                    </p>
                </motion.div>

                {/* VISION SECTION — "Wyobraź sobie..." */}
                <motion.div
                    initial={{opacity: 0, y: 30}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.7}}
                    className="mt-16 p-5 p-md-8 rounded-4 mw-md-4xl mx-auto"
                    style={{
                        ...glassCard,
                        border: '1px solid rgba(255, 255, 255, 0.08)'
                    }}
                >
                    <h3 className="fs-4 fw-bold text-success mb-6 text-center">Wyobraź sobie...</h3>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{once: true}}
                        variants={{
                            hidden: {opacity: 0},
                            visible: {opacity: 1, transition: {staggerChildren: 0.1}}
                        }}
                    >
                        {[
                            'Twoje dziecko samo siada do nauki — bez przypominania',
                            'Wie, co ma zrobić, kiedy zacząć i jak się za to zabrać',
                            'Ty masz czas na kawę, książkę, rozmowę — bez wyrzutów sumienia',
                            'W domu jest spokój. Bez kłótni. Bez napięcia.'
                        ].map((item, index) => (
                            <motion.div
                                key={index}
                                variants={{
                                    hidden: {opacity: 0, y: 10},
                                    visible: {opacity: 1, y: 0, transition: {duration: 0.4}}
                                }}
                                className="d-flex align-items-start gap-3 mb-4"
                            >
                                <i className="bi bi-check-circle-fill text-success fs-7 mt-1"></i>
                                <span className="text-white fw-medium fs-9">{item}</span>
                            </motion.div>
                        ))}
                    </motion.div>
                </motion.div>

                <motion.p
                    initial={{opacity: 0, y: 10}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.5, delay: 0.3}}
                    className="text-center mt-8 fs-8 text-white fw-semibold mw-md-3xl mx-auto"
                >
                    To nie fantazja. To codzienność setek rodzin po Kursie Efektywnego Działania.
                </motion.p>

                {/* THE SHIFT — "Co musi się zmienić?" */}
                <motion.div
                    initial={{opacity: 0, y: 20}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.6}}
                    id="co-musi-sie-zmienic"
                    className="text-center mt-16 mb-8"
                >
                    <h2 className="fs-4 fw-bold text-white mb-3">Co musi się zmienić?</h2>
                    <p className="fs-9 text-secondary-light mw-md-3xl mx-auto">Nie chodzi o lepsze oceny. Chodzi o
                        dziecko, które <span className="text-success fw-bold">samo potrafi się uczyć</span>.</p>
                </motion.div>

                <div className="row g-4 mw-md-5xl mx-auto mb-16">
                    {[
                        {
                            icon: 'bi-heart-fill',
                            color: 'text-danger',
                            title: 'DLACZEGO',
                            subtitle: 'Wewnętrzna motywacja',
                            desc: 'Zamiast "bo mama kazała" — Twoje dziecko samo będzie wiedzieć, po co siada do nauki. Koniec z codziennym przekonywaniem.'
                        },
                        {
                            icon: 'bi-tools',
                            color: 'text-warning',
                            title: 'JAK',
                            subtitle: 'Narzędzia i system',
                            desc: 'Plan dnia, techniki nauki, walka z prokrastynacją — konkretne narzędzia, które działają nawet gdy nie patrzysz.'
                        },
                        {
                            icon: 'bi-bullseye',
                            color: 'text-success',
                            title: 'CO',
                            subtitle: 'Priorytety',
                            desc: 'Dziecko nauczy się, co zrobić najpierw, a co może poczekać. Bez Twojego planowania za nie.'
                        }
                    ].map((pillar, index) => (
                        <div key={index} className="col-12 col-md-4">
                            <motion.div
                                initial={{opacity: 0, y: 20}}
                                whileInView={{opacity: 1, y: 0}}
                                viewport={{once: true}}
                                transition={{duration: 0.5, delay: index * 0.15}}
                                className="h-100 p-4 p-md-5 rounded-4 text-center"
                                style={glassCard}
                            >
                                <i className={`bi ${pillar.icon} ${pillar.color} fs-3 mb-3 d-block`}></i>
                                <h4 className="text-white fw-bold fs-7 mb-1">{pillar.title}</h4>
                                <p className="text-success fs-10 fw-semibold mb-3">{pillar.subtitle}</p>
                                <p className="text-secondary-light fs-11 mb-0">{pillar.desc}</p>
                            </motion.div>
                        </div>
                    ))}
                </div>

                <ResponsivePhotoWithText
                    customWrapperStyles='row mt-8 container mx-auto'
                    photoUrl='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/sales-page/ked-v2-best-choice-preview.png'
                    paddingPhoto='56.25%'
                    textPart={
                        <>
                            <ResponsiveElement mobileClasses='fs-7 text-start mt-8 mt-md-0'
                                               desktopClasses='fs-7 text-start' element={
                                <h3>Nic nie ryzykujesz <img
                                    style={{height: '32px'}}
                                    src='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/ikony/quality.svg'/>
                                </h3>
                            }/>
                            <div className='text-start mt-4'>
                                <p className='fw-medium fs-10'>Obejmuje Cię <b>30-dniowa gwarancja satysfakcji</b>.
                                    Jeżeli po 2 tygodniach nie zobaczysz zmiany — zwrócimy Ci 100% pieniędzy.</p>
                                <p className='fw-medium fs-10'>Zapisz swoje dziecko, daj mu szansę — a jeśli to nie
                                    zadziała, to tak, jakby nic się nie stało. Zero ryzyka po Twojej stronie.</p>
                            </div>
                            <AnimatedLink
                                hashLink={true}
                                to='#kup-teraz'
                                style={{
                                    maxWidth: '350px'
                                }}
                                className='btn btn-lg btn-success fs-10 py-4 w-100 text-success-light shadow mt-3'>Zapisz
                                swoje dziecko na Kurs Efektywnego Działania 2.0</AnimatedLink>

                        </>
                    }/>

                {/* PARENT TRANSFORMATION CARDS */}
                <motion.div
                    initial={{opacity: 0, y: 20}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.6}}
                    className="text-center mt-16 mb-8"
                >
                    <h2 className="fs-4 fw-bold text-white mb-3">Jak zmieni się Wasze życie?</h2>
                    <p className="fs-9 text-secondary-light mw-md-4xl mx-auto">Konkretne zmiany, które zobaczysz w
                        trakcie Kursu — w domu, nie tylko w ocenach.</p>
                </motion.div>

                <div className="row g-4 mw-md-5xl mx-auto mb-16">
                    {[
                        {
                            before: 'Nie wie, po co się uczy',
                            after: 'Wie dokładnie, do czego dąży i dlaczego',
                            module: 'Najlepsza wersja siebie',
                            icon: 'bi-compass'
                        },
                        {
                            before: 'Codzienne przypominanie o nauce',
                            after: 'Dziecko planuje swój dzień samo',
                            module: 'Planowanie i organizacja czasu',
                            icon: 'bi-calendar-check'
                        },
                        {
                            before: 'Ciągłe odkładanie nauki na później',
                            after: 'Dziecko działa systematycznie, bez nacisku',
                            module: 'Koniec z prokrastynacją',
                            icon: 'bi-lightning-charge'
                        },
                        {
                            before: 'Godziny na telefonie zamiast nauki',
                            after: 'Telefon nie jest już problemem',
                            module: 'Optymalizacja telefonu i środowiska',
                            icon: 'bi-phone'
                        },
                        {
                            before: 'Uczy się godzinami, ale nic nie pamięta',
                            after: 'W końcu wie, JAK się uczyć — raz na zawsze',
                            module: 'Efektywna nauka i zapamiętywanie',
                            icon: 'bi-lightbulb'
                        },
                        {
                            before: 'Niska samoocena i brak wiary w siebie',
                            after: 'Silniejsza psychika i jasny plan na przyszłość',
                            module: 'Mindset i pewność siebie',
                            icon: 'bi-shield-check'
                        }
                    ].map((card, index) => (
                        <div key={index} className="col-12 col-md-6">
                            <motion.div
                                initial={{opacity: 0, y: 20}}
                                whileInView={{opacity: 1, y: 0}}
                                viewport={{once: true}}
                                transition={{duration: 0.5, delay: index * 0.1}}
                                className="h-100 p-4 rounded-4"
                                style={glassCard}
                            >
                                <div className="d-flex align-items-center gap-3 mb-3">
                                    <i className={`bi ${card.icon} text-success fs-6`}></i>
                                    <span className="text-white-50 fs-11 fw-medium">{card.module}</span>
                                </div>
                                <div className="d-flex align-items-center gap-3 mb-2">
                                    <div className="rounded-3 px-3 py-2 flex-grow-1"
                                         style={{...glassCard, border: '1px solid rgba(239, 68, 68, 0.12)'}}>
                                        <span className="text-danger fs-11 fw-medium"><i
                                            className="bi bi-x-circle fs-12 me-2"></i>{card.before}</span>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-center my-2">
                                    <i className="bi bi-arrow-down text-success fs-8"></i>
                                </div>
                                <div className="d-flex align-items-center gap-3">
                                    <div className="rounded-3 px-3 py-2 flex-grow-1"
                                         style={{...glassCard, border: '1px solid rgba(42, 209, 103, 0.12)'}}>
                                        <span className="text-success fs-11 fw-medium"><i
                                            className="bi bi-check-circle fs-12 me-2"></i>{card.after}</span>
                                    </div>
                                </div>
                            </motion.div>
                        </div>
                    ))}
                </div>

                <ResponsivePhotoWithText
                    customWrapperStyles='row mt-16 container mx-auto'
                    photoUrl='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/sales-page/md-800-1080.png'
                    paddingPhoto='135%'
                    customColText='col-md-8'
                    customColImage='col-md-4'
                    imageBelowText={true}
                    swap={true}
                    textPart={
                        <>
                            <ResponsiveElement mobileClasses='fs-7 text-start mt-8 mt-md-0'
                                               desktopClasses='fs-7 text-start' element={
                                <h3>Wiadomość od Twórcy Kursu
                                </h3>
                            }/>
                            <div className='text-start mt-4'>
                                <p className='fw-medium fs-10'>Wiem, jak ciężko jest patrzeć na dziecko, które ma
                                    potencjał, ale nie potrafi go wykorzystać. Wiem, bo rozmawiam z rodzicami takimi jak
                                    Ty każdego tygodnia.</p>
                                <p className='fw-medium fs-10'>Widzę zmęczenie. Frustrację. I ogromną miłość, która za
                                    tym stoi.</p>
                                <p className='fw-medium fs-10'>Stworzyłem ten Kurs, bo szkoła nie uczy najważniejszego
                                    — <b>jak się uczyć</b>. A rodzice nie powinni musieć wypełniać tej luki sami,
                                    każdego dnia, kosztem relacji z dzieckiem.</p>
                                <p className='fw-medium fs-10'>Pomogliśmy już setkom rodzin odzyskać spokój w domu. Chcę
                                    pomóc też Twojej.</p>
                                <p className='fw-medium fs-11'><i>~Mikołaj Dyblik, założyciel Produkacji i twórca Kursu
                                    Efektywnego Działania</i></p>
                            </div>

                        </>
                    }/>
                <ResponsivePhotoWithText
                    customWrapperStyles='row mt-16 container mx-auto'
                    photoUrl='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/sales-page/ked-v2-devices-preview.png'
                    paddingPhoto='56.25%'
                    imageBelowText={true}
                    textPart={
                        <>
                            <ResponsiveElement mobileClasses='fs-7 text-start mt-8 mt-md-0'
                                               desktopClasses='fs-7 text-start' element={
                                <h3>Czym jest <u>Kurs Efektywnego Działania 2.0</u>? <img
                                    style={{height: '32px'}}
                                    src='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/ikony/quality.svg'/>
                                </h3>
                            }/>
                            <div className='text-start mt-4'>
                                <p className='fw-medium fs-10'>6-tygodniowy program stworzony <b>specjalnie dla
                                    nastolatków</b> —
                                    jedyny w Polsce — łączący teorię z dużą dawką praktyki. Dostęp na całe życie.</p>
                                <p className='fw-medium fs-10 text-success'><i className='bi bi-arrow-right me-2'></i>Dziecko
                                    dostaje system, który działa <b>bez Twojego nadzoru</b>.</p>
                                <p className='fw-medium fs-10 text-success'><i className='bi bi-arrow-right me-2'></i>6
                                    tygodni — i masz dziecko, które wie <b>JAK</b> się uczyć.</p>
                                <p className='fw-medium fs-10 text-success'><i className='bi bi-arrow-right me-2'></i>Materiał
                                    we własnym tempie — <b>bez presji i pośpiechu</b>.</p>
                            </div>

                        </>
                    }/>

                <SimpleTestimonial name='Julia'
                                   quote='Cały kurs był dla mnie bardzo przydatny, pomógł mi bardziej uporządkować dzień i zdać sobie sprawę z wielu faktów. Z natury jestem osobą działającą chaotycznie, więc najbardziej wartościowe dla mnie było poznanie sposobów na zdobycie kontroli nad moim czasem. Bardzo wartościowe były też tematy o tworzeniu własnego obrazu w głowie i tym, jak dzięki temu zmieni się nasze zachowanie.'
                                   imageUrl='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/sales-page/julia-incognito.png'
                                   smallerQuote={true}
                                   description='Uczennica IV Klasy Liceum'
                />

                {/* ═══════════════ COST COMPARISON ═══════════════ */}
                <TutoringComparisonSection kedPrice={referralPrice} persona="parent" />

                {/* 1st Purchase CTA */}
                <div id='kup-teraz'>
                    <Heading badgeText='Pozostał ostatni krok'
                             title='Zapewnij swojemu dziecku narzędzia na całe życie 📚'/>
                    {renderPricingSection()}
                </div>

                <h3 className='mt-16 fs-5 text-success'>30-dniowa Gwarancja Satysfakcji <img
                    style={{height: '68px'}}
                    alt='jakość'
                    src='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/ikony/quality.svg'/>
                </h3>
                <DependentOnScreenSizeElement mobileElement={<img style={{height: '192px'}}
                                                                  src="https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/gwarancja.png"
                                                                  alt='gwarancja'/>}
                                              desktopElement={<img style={{height: '256px'}}
                                                                   src="https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/gwarancja.png"
                                                                   alt='gwarancja'/>}/>
                <p className='fw-medium mx-auto mw-md-2xl fs-9 mt-6'>Nic nie ryzykujesz. Jeżeli po przerobieniu dwóch pierwszych tygodni Twoje dziecko uzna, że to nie dla niego — <b>zwrócimy 100% pieniędzy</b>.</p>

                <p className='fw-medium mx-auto mw-md-2xl fs-10 mt-6'>Wiem, że to duża decyzja. Dlatego daję Ci <b>30-dniową
                    gwarancję satysfakcji</b> — żebyś mógł/mogła podjąć ją bez stresu. Twoje dziecko przejdzie przez
                    program, a Ty zobaczysz, czy to działa.</p>

                <p className='fw-medium mx-auto mw-md-2xl fs-9 mt-6' style={{maxWidth: "660px"}}>Zapisz swoje dziecko
                    już teraz. Jedyne ryzyko
                    to <u>nie spróbować</u> — i zostać z tym samym problemem za miesiąc, za pół roku, za rok.</p>

                <div className='mt-16'/>

                <ResponsivePhotoWithText
                    customWrapperStyles='row mt-8 container mx-auto'
                    photoUrl='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/sales-page/community.png'
                    paddingPhoto='56.25%'
                    imageBelowText={true}
                    textPart={
                        <>
                            <ResponsiveElement mobileClasses='fs-7 text-start mt-8 mt-md-0'
                                               desktopClasses='fs-7 text-start' element={
                                <h3>Dożywotni dostęp do naszej
                                    prywatnej społeczności
                                </h3>
                            }/>
                            <div className='text-start mt-4'>
                                <p className='fw-medium fs-10'><i>Jesteś sumą 5 osób, z którymi spędzasz najwięcej
                                    czasu.</i></p>
                                <p className='fw-medium fs-10'>Twoje dziecko będzie otoczone ambitnymi rówieśnikami,
                                    którzy też chcą się rozwijać. <b>Nie musisz już szukać motywacji za dwoje</b> —
                                    otoczenie zrobi to naturalnie.</p>
                                <p className='fw-medium fs-10'>Stanie się takie jak oni:
                                    ambitne,
                                    nastawione na rozwój, chętnie wychodzące ze swojej strefy komfortu i skutecznie
                                    realizujące swoje cele.</p>
                            </div>

                        </>
                    }/>

                <div className='mt-16'/>

                <ResponsivePhotoWithText
                    customWrapperStyles='row mt-8 container mx-auto'
                    photoUrl='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/sales-page/zoom-meetings.png'
                    paddingPhoto='56.25%'
                    swap={true}
                    imageBelowText={true}
                    textPart={
                        <>
                            <ResponsiveElement mobileClasses='fs-7 text-start mt-8 mt-md-0'
                                               desktopClasses='fs-7 text-start' element={
                                <h3>Dożywotni dostęp do regularnych
                                    spotkań online z twórcą kursu
                                </h3>
                            }/>
                            <div className='text-start mt-4'>
                                <p className='fw-medium fs-10'>Dzięki cotygodniowym spotkaniom na żywo możemy
                                    pomóc każdej osobie w czasie rzeczywistym i upewnić się,
                                    że każdy odniesie sukces.</p>
                                <p className='fw-medium fs-10'><b>Co to oznacza dla Ciebie?</b> Twoje dziecko ma
                                    wsparcie mentora — nie musisz być jedyną osobą, która go motywuje i pilnuje.</p>
                                <p className='fw-medium fs-10'>Godzina konsultacji z Mikołajem kosztuje <b>1000PLN+</b>,
                                    więc otrzymujecie niesamowity bonus - i to na całe życie.</p>
                            </div>

                        </>
                    }/>

                <SimpleTestimonial name='Dominik' quote='Najbardziej osobiście podoba mi sie Twoje realne podejście. To znaczy, że nie sprzedajesz gruszek na wierzbie i nie
    klepiesz po ramionku, tylko efektywnie motywujesz i pokazujesz właśnie te techniki i narzedzia, dzięki którym można
    naprawdę wiele zdziałać w życiu. Z rzeczy które mi sie przydały i które wiem, że działają to chyba nie muszę mówić,
    bo to jest jakieś 80% materiału i ciężko trochę powiedzieć co konkretnie.'
                                   imageUrl='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/testimonials/dominik.png'
                                   smallerQuote={true}
                                   description='Student ekonomii'
                />

                {/* 2nd Purchase CTA */}
                <Heading badgeText='Pozostał ostatni krok' title='Zapewnij swojemu dziecku narzędzia na całe życie 📚'/>
                {renderPricingSection()}

                {/* CURATED REVIEWS */}
                <motion.div
                    initial={{opacity: 0, y: 20}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.6}}
                    className="text-center mt-10 mb-8"
                >
                    <h3 className="fs-4 fw-bold text-white mb-3">Co mówią uczniowie i rodzice po Kursie</h3>
                    <p className="fs-10 text-secondary-light">Autentyczne opinie od naszych Kursantów i ich rodziców</p>
                    <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mt-4">
                        <div className="d-flex align-items-center gap-1">
                            {[1, 2, 3, 4, 5].map(i => (
                                <i key={i} className="bi bi-star-fill text-warning fs-9"></i>
                            ))}
                        </div>
                        <span className="text-white fw-semibold fs-10">{displayAverage}</span>
                        <span className="text-white-50 fs-11">({reviewCount} opinii)</span>
                    </div>
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true}}
                    variants={{
                        hidden: {opacity: 0},
                        visible: {opacity: 1, transition: {staggerChildren: 0.08}}
                    }}
                    className="row g-3 mw-md-5xl mx-auto mb-6"
                >
                    {curatedSalesReviews.map((review, index) => {
                        const isMaria = review.name === 'Maria';
                        return (
                            <motion.div
                                key={index}
                                variants={{
                                    hidden: {opacity: 0, y: 15},
                                    visible: {opacity: 1, y: 0, transition: {duration: 0.4}}
                                }}
                                className={isMaria ? 'col-12' : 'col-12 col-md-6'}
                            >
                                <div className={`p-4 rounded-3 h-100 ${isMaria ? 'text-center py-5' : ''}`} style={{
                                    ...glassCard,
                                    ...(isMaria ? {border: '1px solid rgba(42, 209, 103, 0.15)'} : {})
                                }}>
                                    <div
                                        className={`d-flex align-items-center gap-1 mb-2 ${isMaria ? 'justify-content-center' : ''}`}>
                                        {Array.from({length: review.rating}).map((_, i) => (
                                            <i key={i} className="bi bi-star-fill text-warning fs-11"></i>
                                        ))}
                                    </div>
                                    <p className={`text-white mb-2 fst-italic ${isMaria ? 'fs-9 fw-medium mw-md-3xl mx-auto' : 'fs-11'}`}>"{stripHtml(review.review)}"</p>
                                    <div
                                        className={`d-flex align-items-center gap-2 ${isMaria ? 'justify-content-center' : ''}`}>
                                        <span className="text-success fw-semibold fs-11">{review.name}</span>
                                        {review.details &&
                                            <span className="text-white-50 fs-12">— {review.details}</span>}
                                    </div>
                                </div>
                            </motion.div>
                        );
                    })}
                </motion.div>

                <div className="text-center mb-8">
                    <Link to="/opinie" className="text-success fw-medium fs-10 text-decoration-underline">
                        Zobacz wszystkie opinie <i className="bi bi-arrow-right ms-1"></i>
                    </Link>
                </div>

                {/* Program Kursu - 6 tygodni */}
                <div className='fw-medium mw-md-4xl mx-auto text-center mt-16'>
                    <h3 className='fs-4'>Program Kursu Efektywnego Działania 2.0™</h3>
                    <p>6 tygodni, po których Twoje dziecko będzie wiedzieć JAK się uczyć i JAK działać — a Ty
                        nie będziesz musieć już o tym przypominać.</p>
                    <p className='fs-10 text-secondary-light'>Każdy tydzień to konkretne narzędzia, które dziecko od
                        razu wdraża w życie.</p>
                </div>

                {/* Week 1 */}
                <ResponsivePhotoWithText
                    customWrapperStyles='row mt-10 container mx-auto'
                    photoUrl=''
                    paddingPhoto='0'
                    swap={false}
                    imageBelowText={true}
                    customColText='col-md-6'
                    customColImage='col-md-6'
                    textPart={
                        <>
                            <ResponsiveElement mobileClasses='fs-7 text-start mt-8 mt-md-0'
                                               desktopClasses='fs-7 text-start' element={
                                <h3>Tydzień 1: {kedV2CourseStructure[1].title}</h3>
                            }/>
                            <div className='text-start mt-4'>
                                <p className='fw-medium fs-10 text-warning'><i
                                    className='bi bi-exclamation-triangle me-2'></i>Twoje dziecko nie wie, kim chce
                                    być? Nie ma jasnego celu? Ciągle coś je rozprasza?</p>
                                <p className='fw-medium fs-10'>W tym tygodniu Twoje dziecko:</p>
                                <ul className='fs-10 mb-3'>
                                    <li>Stworzy wizję swojej <b>idealnej wersji siebie</b> (BEST Self)</li>
                                    <li><b>Zoptymalizuje swoje środowisko</b> - telefon, komputer i biurko przestaną
                                        rozpraszać
                                    </li>
                                    <li>Pozna <b>Plan Dominacji</b> - prosty system planowania każdego dnia</li>
                                    <li>Zrozumie rolę swojego <b>nastawienia</b> i zda sobie sprawę, jak to wpływa na
                                        sukces
                                    </li>
                                </ul>
                                <p className='fw-medium fs-10 text-success'><i
                                    className='bi bi-check-circle me-2'></i><b>Rezultat:</b> Jasny cel, uporządkowane
                                    środowisko, nastawienie na rozwój.</p>
                            </div>
                        </>
                    }
                    customComponentInsteadOfPhoto={
                        <div className='position-relative' style={{top: 0, left: 0}}>
                            <p className='text-success fw-semibold fs-10 mb-3'>Lekcje w tym tygodniu:</p>
                            <ul className='list-unstyled mb-0'>
                                {kedV2CourseStructure[1].episodes.map((episode, idx) => (
                                    <li key={idx} className='d-flex align-items-start gap-2 mb-2'>
                                        <i className='bi bi-play-circle text-success fs-10 mt-1'></i>
                                        <span className='text-white opacity-75 fs-11'>{episode.title}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    }/>
                <img
                    className='img-fluid mw-md-md mx-auto d-none d-md-block'
                    src='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/sales-page/arrow-long-right.png'
                    alt='strzałka'/>

                {/* Week 2 */}
                <ResponsivePhotoWithText
                    customWrapperStyles='row mt-10 container mx-auto'
                    photoUrl=''
                    paddingPhoto='0'
                    swap={true}
                    imageBelowText={true}
                    customColText='col-md-6'
                    customColImage='col-md-6'
                    textPart={
                        <>
                            <ResponsiveElement mobileClasses='fs-7 text-start mt-8 mt-md-0'
                                               desktopClasses='fs-7 text-start' element={
                                <h3>Tydzień 2: {kedV2CourseStructure[2].title}</h3>
                            }/>
                            <div className='text-start mt-4'>
                                <p className='fw-medium fs-10 text-warning'><i
                                    className='bi bi-exclamation-triangle me-2'></i>Twoje dziecko ciągle odkłada
                                    naukę na później? Działa tylko gdy "ma motywację"? Nie potrafi się skupić?</p>
                                <p className='fw-medium fs-10'>W tym tygodniu Twoje dziecko:</p>
                                <ul className='fs-10 mb-3'>
                                    <li>Zrozumie, dlaczego <b>nawyki są silniejsze niż motywacja</b></li>
                                    <li>Pozna sprawdzone <b>techniki antyprokrastynacyjne</b></li>
                                    <li>Nauczy się <b>zwiększać koncentrację</b> i utrzymywać skupienie</li>
                                    <li>Opanuje <b>Matrycę Eisenhowera</b> do określania priorytetów</li>
                                    <li>Zrozumie rolę <b>marginalnych zysków</b> - i dowie się, jak je znajdować.</li>
                                </ul>
                                <p className='fw-medium fs-10 text-success'><i
                                    className='bi bi-check-circle me-2'></i><b>Rezultat:</b> Koniec z prokrastynacją,
                                    systematyczne działanie bez potrzeby motywacji.</p>
                            </div>
                        </>
                    }
                    customComponentInsteadOfPhoto={
                        <div className='position-relative' style={{top: 0, left: 0}}>
                            <p className='text-success fw-semibold fs-10 mb-3'>Lekcje w tym tygodniu:</p>
                            <ul className='list-unstyled mb-0'>
                                {kedV2CourseStructure[2].episodes.map((episode, idx) => (
                                    <li key={idx} className='d-flex align-items-start gap-2 mb-2'>
                                        <i className='bi bi-play-circle text-success fs-10 mt-1'></i>
                                        <span className='text-white opacity-75 fs-11'>{episode.title}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    }/>
                <img
                    className='img-fluid mw-md-md mx-auto d-none d-md-block'
                    src='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/sales-page/arrow-long-left.png'
                    alt='strzałka'/>

                {/* Week 3 */}
                <ResponsivePhotoWithText
                    customWrapperStyles='row mt-10 container mx-auto'
                    photoUrl=''
                    paddingPhoto='0'
                    swap={false}
                    imageBelowText={true}
                    customColText='col-md-6'
                    customColImage='col-md-6'
                    textPart={
                        <>
                            <ResponsiveElement mobileClasses='fs-7 text-start mt-8 mt-md-0'
                                               desktopClasses='fs-7 text-start' element={
                                <h3>Tydzień 3: {kedV2CourseStructure[3].title}</h3>
                            }/>
                            <div className='text-start mt-4'>
                                <p className='fw-medium fs-10 text-warning'><i
                                    className='bi bi-exclamation-triangle me-2'></i>Twoje dziecko uczy się
                                    godzinami, ale szybko zapomina? Nie wie, jak skutecznie powtarzać materiał?</p>
                                <p className='fw-medium fs-10'>W tym tygodniu Twoje dziecko:</p>
                                <ul className='fs-10 mb-3'>
                                    <li>Pozna <b>metodę POP</b> - Powtarzanie, Odzyskiwanie, Przeplatanie</li>
                                    <li>Nauczy się <b>skutecznie powtarzać</b> materiał wg krzywej zapominania</li>
                                    <li>Zrozumie <b>rolę snu w nauce</b> i jak ją wykorzystać</li>
                                    <li>Opanuje <b>planowanie SMART</b> - konkretne, mierzalne cele</li>
                                    <li>Nauczy się <b>planować naukę z pomocą AI</b> na platformie Produkacji</li>
                                </ul>
                                <p className='fw-medium fs-10 text-success'><i
                                    className='bi bi-check-circle me-2'></i><b>Rezultat:</b> Zapamiętywanie materiału na
                                    dłużej, efektywne powtórki, więcej czasu na inne rzeczy</p>
                            </div>
                        </>
                    }
                    customComponentInsteadOfPhoto={
                        <div className='position-relative' style={{top: 0, left: 0}}>
                            <p className='text-success fw-semibold fs-10 mb-3'>Lekcje w tym tygodniu:</p>
                            <ul className='list-unstyled mb-0'>
                                {kedV2CourseStructure[3].episodes.map((episode, idx) => (
                                    <li key={idx} className='d-flex align-items-start gap-2 mb-2'>
                                        <i className='bi bi-play-circle text-success fs-10 mt-1'></i>
                                        <span className='text-white opacity-75 fs-11'>{episode.title}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    }/>
                <img
                    className='img-fluid mw-md-md mx-auto d-none d-md-block'
                    src='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/sales-page/arrow-long-right.png'
                    alt='strzałka'/>

                {/* Week 4 */}
                <ResponsivePhotoWithText
                    customWrapperStyles='row mt-10 container mx-auto'
                    photoUrl=''
                    paddingPhoto='0'
                    swap={true}
                    imageBelowText={true}
                    customColText='col-md-6'
                    customColImage='col-md-6'
                    textPart={
                        <>
                            <ResponsiveElement mobileClasses='fs-7 text-start mt-8 mt-md-0'
                                               desktopClasses='fs-7 text-start' element={
                                <h3>Tydzień 4: {kedV2CourseStructure[4].title}</h3>
                            }/>
                            <div className='text-start mt-4'>
                                <p className='fw-medium fs-10 text-warning'><i
                                    className='bi bi-exclamation-triangle me-2'></i>Twoje dziecko stresuje się przed
                                    sprawdzianami? Nie wie, jak robić dobre notatki? Marnuje czas na lekcjach?</p>
                                <p className='fw-medium fs-10'>W tym tygodniu Twoje dziecko:</p>
                                <ul className='fs-10 mb-3'>
                                    <li>Opanuje <b>skuteczną naukę na lekcji</b> - wyciśnie maksimum ze szkoły</li>
                                    <li>Pozna <b>techniki egzaminacyjne</b> - pisanie sprawdzianów na topowe wyniki</li>
                                    <li>Stworzy <b>efektywne notatki i fiszki</b></li>
                                    <li>Zbuduje <b>rutynę przed nauką</b> - szybszy start, lepsza koncentracja</li>
                                    <li>Nauczy się <b>radzić sobie ze stresem</b> i skutecznie realizować cele</li>
                                </ul>
                                <p className='fw-medium fs-10 text-success'><i
                                    className='bi bi-check-circle me-2'></i><b>Rezultat:</b> Praktyczne narzędzia do
                                    codziennej nauki, więcej wiedzy wyniesionej z lekcji i mniej stresu przed
                                    sprawdzianami</p>
                            </div>
                        </>
                    }
                    customComponentInsteadOfPhoto={
                        <div className='position-relative' style={{top: 0, left: 0}}>
                            <p className='text-success fw-semibold fs-10 mb-3'>Lekcje w tym tygodniu:</p>
                            <ul className='list-unstyled mb-0'>
                                {kedV2CourseStructure[4].episodes.map((episode, idx) => (
                                    <li key={idx} className='d-flex align-items-start gap-2 mb-2'>
                                        <i className='bi bi-play-circle text-success fs-10 mt-1'></i>
                                        <span className='text-white opacity-75 fs-11'>{episode.title}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    }/>
                <img
                    className='img-fluid mw-md-md mx-auto d-none d-md-block'
                    src='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/sales-page/arrow-long-left.png'
                    alt='strzałka'/>

                {/* Week 5 */}
                <ResponsivePhotoWithText
                    customWrapperStyles='row mt-10 container mx-auto'
                    photoUrl=''
                    paddingPhoto='0'
                    swap={false}
                    imageBelowText={true}
                    customColText='col-md-6'
                    customColImage='col-md-6'
                    textPart={
                        <>
                            <ResponsiveElement mobileClasses='fs-7 text-start mt-8 mt-md-0'
                                               desktopClasses='fs-7 text-start' element={
                                <h3>Tydzień 5: {kedV2CourseStructure[5].title}</h3>
                            }/>
                            <div className='text-start mt-4'>
                                <p className='fw-medium fs-10 text-warning'><i
                                    className='bi bi-exclamation-triangle me-2'></i>Twoje dziecko ma problem z
                                    przedmiotami ścisłymi? Nie potrafi wejść w stan skupienia? Musi nadrabiać duże
                                    zaległości?</p>
                                <p className='fw-medium fs-10'>W tym tygodniu Twoje dziecko:</p>
                                <ul className='fs-10 mb-3'>
                                    <li>Dowie się, <b>kiedy mózg najlepiej zapamiętuje</b> informacje</li>
                                    <li>Opanuje <b>naukę poprzez dociekanie</b> - głębsze zrozumienie</li>
                                    <li>Nauczy się tworzyć <b>mapy myśli</b> do trudnych tematów</li>
                                    <li>Pozna <b>skuteczną naukę do przedmiotów ścisłych</b></li>
                                    <li>Odkryje, jak wchodzić w <b>stan flow</b> i <b>nadrabiać materiał w 1-2 dni</b>
                                    </li>
                                </ul>
                                <p className='fw-medium fs-10 text-success'><i
                                    className='bi bi-check-circle me-2'></i><b>Rezultat:</b> Zaawansowane techniki
                                    nauki, umiejętność szybkiego nadrabiania zaległości.</p>
                            </div>
                        </>
                    }
                    customComponentInsteadOfPhoto={
                        <div className='position-relative' style={{top: 0, left: 0}}>
                            <p className='text-success fw-semibold fs-10 mb-3'>Lekcje w tym tygodniu:</p>
                            <ul className='list-unstyled mb-0'>
                                {kedV2CourseStructure[5].episodes.map((episode, idx) => (
                                    <li key={idx} className='d-flex align-items-start gap-2 mb-2'>
                                        <i className='bi bi-play-circle text-success fs-10 mt-1'></i>
                                        <span className='text-white opacity-75 fs-11'>{episode.title}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    }/>
                <img
                    className='img-fluid mw-md-md mx-auto d-none d-md-block'
                    src='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/sales-page/arrow-long-right.png'
                    alt='strzałka'/>

                {/* Week 6 */}
                <ResponsivePhotoWithText
                    customWrapperStyles='row mt-10 container mx-auto mb-16'
                    photoUrl=''
                    paddingPhoto='0'
                    swap={true}
                    imageBelowText={true}
                    customColText='col-md-6'
                    customColImage='col-md-6'
                    textPart={
                        <>
                            <ResponsiveElement mobileClasses='fs-7 text-start mt-8 mt-md-0'
                                               desktopClasses='fs-7 text-start' element={
                                <h3>Tydzień 6: {kedV2CourseStructure[6].title}</h3>
                            }/>
                            <div className='text-start mt-4'>
                                <p className='fw-medium fs-10 text-warning'><i
                                    className='bi bi-exclamation-triangle me-2'></i>Twoje dziecko ma niską
                                    samoocenę? Nie wierzy w siebie? Otacza się niewłaściwymi ludźmi?</p>
                                <p className='fw-medium fs-10'>W tym tygodniu Twoje dziecko:</p>
                                <ul className='fs-10 mb-3'>
                                    <li>Nauczy się <b>prowadzić dziennik</b> - potężne narzędzie do budowy
                                        samoświadomości
                                    </li>
                                    <li>Zrozumie znaczenie <b>autentyczności</b> i bycia sobą</li>
                                    <li>Odkryje, jak <b>otoczenie wpływa na sukces</b></li>
                                    <li>Poprawi <b>obraz siebie i samoocenę</b></li>
                                    <li>Zrozumie <b>rolę przekonań</b> i nauczy się myśleć jak zwycięzca</li>
                                </ul>
                                <p className='fw-medium fs-10 text-success'><i
                                    className='bi bi-check-circle me-2'></i><b>Rezultat:</b> Silniejsza psychika, wyższa
                                    samoocena, jasny plan na przyszłość.</p>
                            </div>
                        </>
                    }
                    customComponentInsteadOfPhoto={
                        <div className='position-relative' style={{top: 0, left: 0}}>
                            <p className='text-success fw-semibold fs-10 mb-3'>Lekcje w tym tygodniu:</p>
                            <ul className='list-unstyled mb-0'>
                                {kedV2CourseStructure[6].episodes.map((episode, idx) => (
                                    <li key={idx} className='d-flex align-items-start gap-2 mb-2'>
                                        <i className='bi bi-play-circle text-success fs-10 mt-1'></i>
                                        <span className='text-white opacity-75 fs-11'>{episode.title}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    }/>

                {/* Example Lesson Video */}
                <div className='mt-16 text-center'>
                    <h3 className='fs-5 mb-4'>Zobacz przykładową lekcję z Kursu</h3>
                    <p className='text-white opacity-75 mb-6'>Przekonaj się, jak wyglądają nasze materiały!</p>
                    <VideoWithPlayButton
                        vimeoVideoId='1140696708'
                        id='example-lesson'
                        rounded={true}
                        customDivWrapperClasses='mw-md-3xl mx-auto mb-8 position-relative border border-2 border-success rounded-4 overflow-hidden'
                    />
                </div>


                <SimpleTestimonial name='Magdalena'
                                   quote='Czuję, że Hubertowi współpraca z Panem pokazała i uświadomiła parę ważnych rzeczy. Bardzo dziękuję, za to, co do tej pory dał Pan Hubertowi, myślę, że na pewno będzie to dla niego wspierająca wiedza.'
                                   description='Mama Huberta, maturzysty'
                                   imageUrl='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/sales-page/mama-huberta-incognito.png'/>

                {/* Krzysiek Video - ADHD Success Story */}
                <div className='mt-8 text-center'>
                    <h3 className='fs-5 mb-4'>Masz dziecko z ADHD? Zobacz historię Krzyśka</h3>
                    <p className='text-white opacity-75 mb-6 mw-md-3xl mx-auto'>
                        Krzysiek miał ogromne problemy z koncentracją i organizacją. Szybko się to zmieniło... 😄
                    </p>
                    <VideoWithPlayButton
                        vimeoVideoId='1132036775'
                        id='krzysiek-video'
                        rounded={true}
                        customDivWrapperClasses='mw-md-3xl mx-auto mb-4 position-relative border border-2 border-success rounded-4 overflow-hidden'
                    />
                    <p className='text-white opacity-50 fs-11 mt-0'>Fragment z cotygodniowego spotkania z Kursantami
                        (udostępniony za zgodą Krzyśka)</p>
                </div>

                {/* WHO IS THIS FOR — Parent-focused */}
                <motion.div
                    initial={{opacity: 0, y: 20}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.6}}
                    className="text-center mt-16 mb-10"
                >
                    <h2 className="fs-4 fw-bold text-white mb-4">Dla kogo jest ten Kurs?</h2>
                    <p className="fs-9 text-secondary-light">Zanim zdecydujesz — sprawdź, czy to rozwiązanie dla Waszej
                        rodziny</p>
                </motion.div>

                <div className="row g-6 justify-content-center mw-md-5xl mx-auto mb-16">
                    <div className="col-12 col-lg-6">
                        <motion.div
                            initial={{opacity: 0, x: -20}}
                            whileInView={{opacity: 1, x: 0}}
                            viewport={{once: true}}
                            transition={{duration: 0.5}}
                            className="h-100 p-5 p-lg-7 rounded-4"
                            style={{
                                ...glassCard,
                                border: '1px solid rgba(42, 209, 103, 0.12)'
                            }}
                        >
                            <div className="d-flex align-items-center gap-3 mb-5">
                                <h3 className="mb-0 fs-6 fw-bold text-success">Kurs JEST dla Twojego dziecka,
                                    jeśli:</h3>
                            </div>
                            <motion.ul
                                initial="hidden" whileInView="visible" viewport={{once: true}}
                                variants={{
                                    hidden: {opacity: 0},
                                    visible: {opacity: 1, transition: {staggerChildren: 0.1}}
                                }}
                                className="list-unstyled mb-0"
                            >
                                {[
                                    'Chcesz kontrolować mniej — i widzieć więcej samodzielności',
                                    'Twoje dziecko ma przynajmniej 12 lat i chcesz zapewnić mu narzędzia na całe życie',
                                    'W Waszym domu nauka stała się źródłem napięcia',
                                    'Wierzysz, że Twoje dziecko ma potencjał — ale nie wie jak go wykorzystać',
                                    'Jesteś gotowy/a zainwestować w przyszłość dziecka'
                                ].map((item, i) => (
                                    <motion.li key={i} variants={{
                                        hidden: {opacity: 0, y: 10},
                                        visible: {opacity: 1, y: 0, transition: {duration: 0.4}}
                                    }} className="d-flex align-items-center gap-3 mb-4">
                                        <i className="bi bi-check-circle-fill text-success fs-8 flex-shrink-0"></i>
                                        <span className="text-white fw-medium">{item}</span>
                                    </motion.li>
                                ))}
                            </motion.ul>
                        </motion.div>
                    </div>

                    <div className="col-12 col-lg-6">
                        <motion.div
                            initial={{opacity: 0, x: 20}}
                            whileInView={{opacity: 1, x: 0}}
                            viewport={{once: true}}
                            transition={{duration: 0.5}}
                            className="h-100 p-5 p-lg-7 rounded-4"
                            style={{
                                ...glassCard,
                                border: '1px solid rgba(239, 68, 68, 0.12)'
                            }}
                        >
                            <div className="d-flex align-items-center gap-3 mb-5">
                                <h3 className="mb-0 fs-6 fw-bold text-danger">Kurs NIE jest dla Twojego dziecka,
                                    jeśli:</h3>
                            </div>
                            <motion.ul
                                initial="hidden" whileInView="visible" viewport={{once: true}}
                                variants={{
                                    hidden: {opacity: 0},
                                    visible: {opacity: 1, transition: {staggerChildren: 0.1}}
                                }}
                                className="list-unstyled mb-0"
                            >
                                {[
                                    'Szukasz magicznej pigułki, która zmieni dziecko z dnia na dzień',
                                    'Oczekujesz zmiany bez żadnego wysiłku ze strony dziecka',
                                    'Nie jesteś gotowy/a pozwolić dziecku przejąć odpowiedzialność',
                                    'Szukasz korepetycji z konkretnego przedmiotu',
                                    'Wolisz tymczasowe rozwiązania, zamiast prawdziwej zmiany raz na zawsze',
                                ].map((item, i) => (
                                    <motion.li key={i} variants={{
                                        hidden: {opacity: 0, y: 10},
                                        visible: {opacity: 1, y: 0, transition: {duration: 0.4}}
                                    }} className="d-flex align-items-center gap-3 mb-4">
                                        <i className="bi bi-x-circle-fill text-danger fs-8 flex-shrink-0"></i>
                                        <span className="text-white fw-medium">{item}</span>
                                    </motion.li>
                                ))}
                            </motion.ul>
                        </motion.div>
                    </div>
                </div>

                {/* REASSURANCE — "Słowo do Ciebie, Rodzicu" */}
                <motion.div
                    initial={{opacity: 0, y: 20}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.7}}
                    className="mt-8 mb-16 p-5 p-md-8 rounded-4 mw-md-3xl mx-auto text-center"
                    style={{
                        ...glassCard,
                        border: '1px solid rgba(255, 255, 255, 0.08)'
                    }}
                >
                    <h3 className="fs-5 fw-bold text-white mb-5">Słowo do Ciebie, Rodzicu</h3>
                    <div className="d-flex flex-column gap-4">
                        <p className="fs-6 text-white fw-bold mb-0">Nie jesteś złym rodzicem.</p>
                        <p className="fs-10 text-secondary-light mb-0">To, że szukasz rozwiązania, dowodzi, jak bardzo
                            Ci zależy.</p>
                        <p className="fs-10 text-secondary-light mb-0">Twoje dziecko nie jest leniwe. Nikt go po prostu
                            nie nauczył <span className="text-success fw-bold">JAK</span> się uczyć.</p>
                        <p className="fs-9 text-success fw-semibold mb-0">I nie jest za późno.</p>
                    </div>
                </motion.div>

                {/* ═══════════════ 30-DAY GUARANTEE ═══════════════ */}
                <h3 className='mt-16 fs-5 text-success'>30-dniowa Gwarancja Satysfakcji <img
                    style={{height: '68px'}}
                    alt='jakość'
                    src='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/ikony/quality.svg'/>
                </h3>
                <DependentOnScreenSizeElement mobileElement={<img style={{height: '192px'}}
                                                                  src="https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/gwarancja.png"
                                                                  alt='gwarancja'/>}
                                              desktopElement={<img style={{height: '256px'}}
                                                                   src="https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/gwarancja.png"
                                                                   alt='gwarancja'/>}/>
                <p className='fw-medium mx-auto mw-md-2xl fs-9 mt-6'>Nic nie ryzykujesz. Jeżeli po przerobieniu dwóch pierwszych tygodni Twoje dziecko uzna, że to nie dla niego — <b>zwrócimy 100% pieniędzy</b>.</p>

                <h3 className='mt-10 fs-6'>Najczęściej zadawane pytania</h3>

                <div className='text-start'>
                    <FaqList items={[
                        {
                            question: "Co dokładnie zawiera Kurs Efektywnego Działania 2.0?",
                            answer: 'Kurs Efektywnego Działania 2.0 to 6-tygodniowy program dla Twojego dziecka. W pakiecie otrzymujesz dostęp do wszystkich materiałów wideo, ćwiczeń, społeczności oraz cotygodniowych spotkań online z twórcą kursu.'
                        },
                        {
                            question: "Czy mogę wykupić Kurs na raty?",
                            answer: 'Tak! Nasz pośrednik płatności oferuje raty 0% rozłożone na dłuższej przestrzeni czasowej. Podczas płatności wystarczy wybrać opcję Raty Pekao lub Raty Alior.'
                        },
                        {
                            question: "Czy mogę zapłacić później",
                            answer: 'Tak, nasz pośrednik płatności oferuje płatności odroczone, takie jak PayPo, Twisto i BLIK płacę później. Na stronie z płatnością wystarczy wybrać opcję "płatności odroczone" i wybrać najlepszy dla siebie sposób płatności.'
                        },
                        {
                            question: "Dla kogo jest ten Kurs?",
                            answer: 'Ten Kurs jest dla wszystkich uczniów w wieku od 12 lat do końca studiów, którzy chcą poprawić swoją efektywność w nauce i działaniu.'
                        },
                        {
                            question: "Ile czasu należy poświęcić na Kurs?",
                            answer: 'Idealnie jest poświęcać około 3-4 godziny w tygodniu. 1.5-2h na obejrzenie materiałów i drugie 1.5-2h na wdrożenie w życie zmian oraz wykonanie ćwiczeń. Wolniejsze przerabianie też jest jak najbardziej możliwe, jednak wtedy ukończenie Kursu zajmie dłużej niż 6 tygodni.'
                        },
                        {
                            question: "Co jeżeli moje dziecko ma problemy z koncentracją?",
                            answer: 'W Kursie uczymy sprawdzonych sposobów na podniesienie koncentracji oraz skupienia, ponieważ bez tego, nie ma Efektywnego Działania. Po wdrożeniu w życie pokazywanych rozwiązań problem z koncentracją pójdzie w niepamięć.'
                        },
                        {
                            question: "Czy ten Program zadziała u dzieci z ADHD?",
                            answer: 'Zdecydowanie. W Kursie specjalnie dostosowaliśmy zarówno długość, jak i treść lekcji, aby nawet osoby z ADHD dały radę obejrzeć całość bez rozpraszania się. Dodatkowo uczymy, w jaki sposób można pracować nad swoją koncentracją oraz skupieniem, dzięki czemu osoby z ADHD widzą rezultaty najszybciej!'
                        },
                        {
                            question: "Co jeżeli to nie zadziała u mojego dziecka?",
                            answer: 'Nie ma problemu, pokaż nam, że próbowało i przerobiło przynajmniej 2 pierwsze tygodnie Kursu, a osobiście znajdę przyczynę i zaproponuję mu plan działania. Jeżeli wciąż z jakiegoś powodu nie będzie zadowolone lub nie będzie widziało rezultatów, napisz nam wiadomość na maila kontakt@produkacja.pl w ciągu 30 dni od zakupu, a zwrócimy Ci 100% pieniędzy.'
                        },
                        {
                            question: "Czym różni się Kurs Efektywnego Działania 2.0 od poprzedniej wersji Kursu?",
                            answer: 'Kurs Efektywnego Działania 2.0 to najnowsza, uaktualniona i udoskonalona wersja na podstawie doświadczeń 700+ rodzin. Bardziej angażujące materiały, zadania, quizy oraz dynamiczny montaż - czyli to, co nastolatkowie kochają najbardziej.',
                        },
                        {
                            question: "Jak mogę wspierać dziecko podczas Kursu?",
                            answer: 'Najważniejsze to dać dziecku przestrzeń i zaufanie. Nie kontroluj każdego kroku — zamiast tego pytaj, co nowego się dowiedziało. Okazuj zainteresowanie bez nacisku. Kurs jest zaprojektowany tak, żeby dziecko mogło przechodzić go samodzielnie, ale Twoje wsparcie emocjonalne ma ogromne znaczenie.'
                        },
                        {
                            question: "Co jeżeli moje dziecko nie chce? Muszę go zmuszać?",
                            answer: 'Nie musisz i nie powinieneś/aś zmuszać. Kurs został zaprojektowany tak, żeby motywacja rosła od środka — dynamiczny montaż, angażujące zadania i rówieśnicza społeczność sprawiają, że nastolatki CHCĄ go przerabiać. Na starcie wystarczy delikatna zachęta. A jeżeli po pierwszych lekcjach dziecko wciąż nie chce — obejmuje Was 30-dniowa gwarancja.'
                        },
                        {
                            question: "Co jeżeli moje dziecko nie mówi biegle po polsku?",
                            answer: 'Treści na platformie (nawigacja, opisy, ćwiczenia) są w języku polskim, więc dziecko powinno rozumieć polski na tyle, żeby się po niej poruszać. Natomiast wszystkie lekcje wideo w Kursie mają dostępne napisy w języku angielskim, które mogą pomóc w zrozumieniu materiału.'
                        },
                        {
                            question: "Czy mogę kupić Kurs z zagranicy?",
                            answer: 'Tak! Jeżeli nie masz polskiego konta bankowego, nasz pośrednik płatności Tpay umożliwia płatność m.in. przez PayPal. Możesz również skorzystać z płatności kartą przez Stripe lub wykonać zwykły przelew bankowy.'
                        },
                        {
                            question: "Czy jeżeli nie wykupię dostępu teraz, cena pójdzie w górę?",
                            answer: 'Tak, ta oferta za 3000 PLN jest dostępna wyłącznie przez link polecający. Standardowa cena to 6000 PLN.'
                        }
                    ]}/>
                </div>


                <motion.div
                    initial={{opacity: 0, y: 20}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.6}}
                    className="mt-8 p-5 rounded-4 mw-md-3xl mx-auto text-center"
                    style={{
                        ...glassCard,
                        border: '1px solid rgba(42, 209, 103, 0.15)'
                    }}
                >
                    <i className="bi bi-quote text-success fs-3 d-block mb-3"></i>
                    <p className="fs-9 text-white fw-medium fst-italic mb-3">"Kurs wartościowy dla nastolatka,
                        uświadamia więcej spraw niż dorosły mógłby podejrzewać że będą dla dziecka nowością."</p>
                    <p className="text-success fw-semibold fs-10 mb-0">Maria — mama nastolatki</p>
                </motion.div>

                {/* Final CTA */}
                <div className="mt-16">
                    <Heading badgeText='Pozostał ostatni krok'
                             title='Zapewnij swojemu dziecku narzędzia na całe życie 📚'/>
                </div>
                {renderPricingSection()}
            </div>
        </>
    );
}
